import { useSelector } from 'react-redux'
import { selectSelector } from '../../../../redux/slices/select'

const CurrentItemTitle = () => {
  const {
    currentTransport: { tranTitle = '' } = {},
  } = useSelector(selectSelector)

  return (
    <div className="current_item_title">
      <span className="key">Транспорт</span>
      <div className="value">{tranTitle}</div>
    </div>
  )
}

export default CurrentItemTitle
